// extracted by mini-css-extract-plugin
module.exports = {"btnOutline":"NextSectionButton_btnOutline__RAjnP","disabled":"NextSectionButton_disabled__12ZLB"};